import { QuestionInfo } from "../common/question-info";

export class DemandNeedsQuestionsResult {
  public SalesId: string;
  public DemandNeedsQuestions: QuestionInfo[];
}
